// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YfKxm","skeleton-animation":"styles_skeleton-animation__p2_Ib"};